module.exports = __webpack_public_path__ + "static/media/01.8563ee1b.mp3";